export const copyText = async (text) => {
	if (navigator.clipboard?.writeText) {
		await navigator.clipboard.writeText(text)
		return
	}
	const el = document.createElement('textarea')
	el.value = text
	el.style.position = 'fixed'
	el.style.opacity = '0'
	document.body.appendChild(el)
	el.select()
	const ok = document.execCommand('copy')
	document.body.removeChild(el)
	if (!ok) throw new Error('copy failed')
}
